<template>
  <div class="wrapper">
    <div v-for="message in messages" :key="message.id">
      <div
        class="message-container"
        :class="!message.sent && 'message-container-not-sent'"
        @click="!message.sent && $emit('edit', message.id)"
      >
        <div class="message-info-container">
          <div
            class="message-title"
            :class="message.sent ? 'sent-message-title' : 'not-sent-message-title'"
          >
            {{ message.title }}
          </div>
          <div class="message-text">{{ message.message }}</div>
        </div>
        <div
          v-if="!message.sent"
          class="send-container"
          @click.stop="$emit('sendMessage', message.id)"
        >
          <img class="send-icon" src="/assets/send-icon.svg" alt="Icon" />
          <div class="send-text">SEND</div>
        </div>
        <div v-else class="message-sent-container">
          <img class="message-sent-icon" src="/assets/invite-sent-icon.svg" alt="Icon" />
          <div class="message-sent-text">SENT</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'message-to-attendee-container',
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .wrapper {
    margin-top: 1.5rem;
  }
}
.wrapper {
  max-width: 42.5rem;
}
.message-container {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 1rem;
  background: white;
  border: 2px solid #d9d9d9;
  border-radius: 1rem;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  gap: 8px;
}
.message-container-not-sent:hover {
  background-color: #e6f1f8;
  cursor: pointer;
  border: 2px solid #cee4f2;
}
.message-info-container {
  flex: 1;
  overflow: hidden;
}
.message-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  font-feature-settings: 'pnum' on, 'lnum' on;
}
.sent-message-title {
  color: #666666;
}
.not-sent-message-title {
  color: #0277bd;
}
.message-text {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.send-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  padding: 8px 12px;
}
.send-container:hover {
  cursor: pointer;
  background-color: #0277bd20;
}
.send-text {
  font-family: Raleway;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  color: #0277bd;
}
.message-sent-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  padding: 8px 12px;
}
.message-sent-text {
  font-family: Raleway;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  color: #55a35d;
}
</style>
